import { useEffect, useMemo, useState } from 'react';
import { Grid, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ListTransfer from '../common/ListTransfer';
import RadioGroupField from '../common/RadioGroupField';

import { gettingHoliday } from 'utils/Zones';
import { useZone, useZoneActions } from '../ZoneContext';

const Holiday = ({open}) => {
    const { t } = useTranslation();
    const { updateField } = useZoneActions();
    const zone = useZone();
    const holidayData = zone.holiday;
    const [loading, setLoading] = useState(false);

    // Opciones para los radio groups
    const definedByOptions = useMemo(() => [
        {
            value: 'hours_in_the_holiday',
            label: t('settings.zones.fields.holiday.hours_in_the_holiday')
        },
        {
            value: 'day_division_time',
            label: t('settings.zones.fields.holiday.day_division_time')
        }
    ], [t]);

    const deductedTimeOptions = useMemo(() => [
        { value: 'none', label: t('settings.zones.fields.holiday.none') },
        { value: 'hours_worked', label: t('settings.zones.fields.holiday.hours_worked') },
        { value: 'full_credit', label: t('settings.zones.fields.holiday.full_credit') }
    ], [t]);

    const hoursWorkedBelongToOptions = useMemo(() => [
        {
            value: 'fixed_rule_value',
            label: t('settings.zones.fields.holiday.fixed_rule_value')
        },
        {
            value: 'planned_day_of_entry',
            label: t('settings.zones.fields.holiday.planned_day_of_entry')
        },
        {
            value: 'planned_day_of_departure',
            label: t('settings.zones.fields.holiday.planned_day_of_departure')
        },
        {
            value: 'day_with_most_hours',
            label: t('settings.zones.fields.holiday.day_with_most_hours')
        },
        {
            value: 'day_really_worked',
            label: t('settings.zones.fields.holiday.day_really_worked')
        }
    ], [t]);


    useEffect(() => {
        if (open) {
            setLoading(true);
            gettingHoliday(
                (loading) => setLoading(loading),
                (holidays) => updateField('holiday', 'holidays', holidays)
            );
        }
    }, [open, updateField]);


    return (
        <>
            {
                loading ?
                <Grid container justifyContent="center" sx={{ py: 4 }}>
                    <CircularProgress />
                </Grid> :
                <Grid container spacing={2} sx={{ mt: 1.5 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Typography variant="h6" gutterBottom>
                            {t('settings.zones.fields.holiday.title')}
                        </Typography>
                        <ListTransfer
                            loading={loading}
                            allItems={holidayData.holidays}
                            selectedItems={holidayData.selectedHolidays}
                            onSelectionChange={(selected) => updateField('holiday', 'selectedHolidays', selected)}
                            textLeft={t('settings.zones.fields.holiday.holidays_available')}
                            textRight={t('settings.zones.fields.holiday.selected_holidays')}
                            textSelected={t('settings.zones.fields.holiday.selected')}
                        />
                    </Grid>

                    {/* Campo Defined By */}
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <RadioGroupField
                            label={t('settings.zones.fields.holiday.holiday_zone_defined_by')}
                            value={holidayData.definedBy}
                            onChange={(e) => updateField('holiday', 'definedBy', e.target.value)}
                            options={definedByOptions}
                            name="defined-by"
                        />
                    </Grid>

                    {/* Campo Deducted Time */}
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <RadioGroupField
                            label={t('settings.zones.fields.holiday.time_deducted_from_holiday_credit')}
                            value={holidayData.deductedTime}
                            onChange={(e) => updateField('holiday', 'deductedTime', e.target.value)}
                            options={deductedTimeOptions}
                            name="deducted-time"
                        />
                    </Grid>

                    {/* Campo Hours Worked Belong To */}
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <RadioGroupField
                            label={t('settings.zones.fields.holiday.hours_worked_on_holiday_belong_to')}
                            value={holidayData.hoursWorkedBelongTo}
                            onChange={(e) => updateField('holiday', 'hoursWorkedBelongTo', e.target.value)}
                            options={hoursWorkedBelongToOptions}
                            name="hours-worked-belong-to"
                        />
                    </Grid>
                </Grid>
            }
        </>

    );
};

export default Holiday;